import { Tooltip, TooltipProps } from '@infotech-soe/erp-ui-kit';
import React, { FC } from 'react';

interface WithTooltipProps extends Pick<
  TooltipProps,
  'children' | 'delay' | 'label' | 'placement'
> {
  condition?: boolean;
}

const WithTooltip: FC<WithTooltipProps> = ({ condition, ...props }) =>
  condition ? (
    <Tooltip {...props}>{props.children}</Tooltip>
  ) : (
    <>{props.children}</>
  );

export default WithTooltip;
